import React from "react";
import useShopStore from "../store/useShopStore";
import useUserStore from "../store/useUserStore";

import classes from "./ProductsDetail.module.css";
import AddToCartButton from "../components/AddToCartButton";
// import LoginOrRegisterButton from "../components/LoginOrRegisterButton";
import ButtonLink from "../utils/ButtonLink";
import Spinner from "../utils/Spinner";

export default function ProductsDetail(props) {
  const { product } = useShopStore((state) => state);
  const { user } = useUserStore((state) => state);

  return (
    <div className={classes.detailContainer}>
      {!product && <Spinner />}
      {product && (
        <>
          <div className={classes.detailImageBox}>
            <img
              alt="detail"
              className={classes.detailImage}
              src={product.image}
            />
          </div>
          <div className={classes.detailImageContentBox}>
            <div className={classes.detailInfo}>
              <h2>{product.name}</h2>
              <p>{product.price} EUR</p>
            </div>
            <div className={classes.detailInfoDescription}>
              <p>{product?.description}</p>
            </div>
            <div style={{ display: "flex", gap: "2rem" }}>
              {user ? (
                <AddToCartButton id={product._id} style={{ width: "100%" }}>
                  Add To cart
                </AddToCartButton>
              ) : (
                <ButtonLink to="/login">Log in to Buy</ButtonLink>
              )}
              <ButtonLink to="/all-products">Back To Products</ButtonLink>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
